import React from 'react';
import { Button, PageContainer } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import { MdEdit, MdDelete } from 'react-icons/md';
import './reviewCartAlternate.css';

const mockData = {
  serviceAddress: '1963 Winding Creek Road DR, Walterboro, SC, 120168',
  mailingAddress: '1963 Winding Creek Road DR, Walterboro, SC, 120168',
  planName: '250 Mbps',
  planTag: 'Internet Services',
  planPrice: '$89.95',
  addonName: 'WI-FI Mesh Extender',
  addonPrice: '$3.95',
  installDate: '7/4/2025 10:00 AM',
  modemRental: '$0.00',
  tax: '$0.00',
  discount: '-$0.00',
  orderTotal: '$102.17',
};

const ReviewCartAlternate = ({
  htmlContent,
  token,
  selectedProduct,
  selectedAddOnsData,
  serviceAddress,
  onProceedToTerms,
  installationDate,
  onEditInstallation,
  onAutoPayChange,
  onPaperlessChange,
}) => {
  const [autoPayEnabled, setAutoPayEnabled] = React.useState(true);
  const [paperlessEnabled, setPaperlessEnabled] = React.useState(true);

  // Calculate dynamic discounts based on autopay and paperless settings
  const calculateDiscount = () => {
    let discount = 0;
    // Add $5 discount for autopay
    if (autoPayEnabled) {
      discount += 5;
    }
    // Add $5 discount for paperless billing
    if (paperlessEnabled) {
      discount += 5;
    }
    return discount;
  };

  // Debug logging
  React.useEffect(() => {
    console.log('🛒 ReviewCartAlternate Mounted/Updated');
    console.log(
      '🛒 selectedAddOnsData:',
      JSON.stringify(selectedAddOnsData, null, 2)
    );
    console.log('🛒 installationDate:', installationDate);
    console.log('🛒 selectedProduct:', selectedProduct);
  }, [selectedProduct, selectedAddOnsData, serviceAddress, installationDate]);

  // Format service address
  const formatAddress = () => {
    if (serviceAddress && serviceAddress.addressLine1) {
      return `${serviceAddress.addressLine1}, ${serviceAddress.addressCityName}, ${serviceAddress.addressStateAbbr} ${serviceAddress.addressPostalCode}`;
    }
    return mockData.serviceAddress;
  };

  // Get product details
  const getProductName = () => {
    return selectedProduct?.title || mockData.planName;
  };

  const getProductPrice = () => {
    return selectedProduct?.price || mockData.planPrice;
  };

  const handleAutoPayToggle = (e) => {
    const isChecked = e.target.checked;
    setAutoPayEnabled(isChecked);
    console.log('Auto Pay toggled:', isChecked ? 'yes' : 'no');

    // Call the callback if provided
    if (onAutoPayChange) {
      onAutoPayChange(isChecked);
    }

    // Trigger change event for MultiStepForm to pick up (legacy support)
    const event = new CustomEvent('autopayChange', {
      detail: { value: isChecked ? 'yes' : 'no' },
    });
    window.dispatchEvent(event);
  };

  const handlePaperlessToggle = (e) => {
    const isChecked = e.target.checked;
    setPaperlessEnabled(isChecked);
    console.log('Paperless toggled:', isChecked ? 'yes' : 'no');

    // Call the callback if provided
    if (onPaperlessChange) {
      onPaperlessChange(isChecked);
    }

    // Trigger change event for MultiStepForm to pick up (legacy support)
    const event = new CustomEvent('paperlessChange', {
      detail: { value: isChecked ? 'yes' : 'no' },
    });
    window.dispatchEvent(event);
  };

  const handleEditInstallation = () => {
    console.log('Edit installation clicked');
    if (onEditInstallation) {
      onEditInstallation();
    }
  };

  // Display the installation date (already formatted from self-scheduling)
  const displayInstallationDate = () => {
    if (installationDate) {
      // If it's an object with displayDate, use that
      if (installationDate.displayDate) {
        return installationDate.displayDate;
      }
      // If it's a Date object, format it as M/D/YYYY H:MM AM/PM
      if (installationDate instanceof Date) {
        const month = installationDate.getMonth() + 1;
        const day = installationDate.getDate();
        const year = installationDate.getFullYear();
        let hours = installationDate.getHours();
        const minutes = installationDate
          .getMinutes()
          .toString()
          .padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
      }
      // If it's already a string, return as-is
      return installationDate;
    }
    // Default fallback date
    return 'Not scheduled';
  };

  return (
    <PageContainer className="reviewCartNode-Container">
      <div id="reviewCartNode-screen" className="reviewCartNode-Container">
        <div className="reviewCartNode-Header">
          <h2>Review Cart (Prepaid Plan)</h2>
          <p>
            Please review your order details and select your billing and
            shipping options. Your installation is at no additional cost.
          </p>
        </div>

        <div className="reviewCartNode-Content">
          <div className="reviewCartNode-Details">
            {/* Service Address */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">1</div>
                  <h4>Service Address</h4>
                </div>
                <div
                  className="reviewCartNode-SecondCol"
                  id={ELEMENT_IDS.CHECKOUT_SERVICE_ADDRESS}
                >
                  {formatAddress()}
                </div>
                {/* <button className="reviewCartNode-IconButton">
                  <MdEdit />
                </button> */}
              </div>
            </div>

            {/* Mailing Address */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">2</div>
                  <h4>Mailing Address</h4>
                </div>
                <div
                  className="reviewCartNode-SecondCol"
                  id={ELEMENT_IDS.CHECKOUT_SHIPPING_ADDRESS}
                >
                  {formatAddress()}
                </div>
                {/* <button className="reviewCartNode-IconButton">
                  <MdEdit />
                </button> */}
              </div>
            </div>

            {/* Plan and Packages */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">3</div>
                  <h4>Plan and Packages</h4>
                </div>
                <div className="reviewCartNode-SecondCol">
                  <div className="reviewCartNode-PlanRow">
                    <div className="reviewCartNode-PlanContent">
                      <span className="reviewCartNode-PlanTag">
                        Internet Services Prepaid
                      </span>
                      <h3
                        className="reviewCartNode-PlanName"
                        id={ELEMENT_IDS.CHECKOUT_PLAN_NAME}
                      >
                        {getProductName()}
                      </h3>
                      <div className="reviewCartNode-PlanPriceText">
                        <span
                          className="reviewCartNode-PriceAmount"
                          id={ELEMENT_IDS.CHECKOUT_PLAN_PRICE}
                        >
                          {getProductPrice()}
                        </span>
                        <span className="reviewCartNode-PriceUnit">/month</span>
                      </div>
                    </div>
                    <button
                      className="reviewCartNode-TrashButton"
                      title="Remove plan"
                    >
                      <MdDelete />
                    </button>
                  </div>

                  <div className="reviewCartNode-InstallationInfo">
                    <p className="reviewCartNode-InstallLabel">
                      Installation on
                    </p>
                    <div className="reviewCartNode-InstallDate">
                      <span id={ELEMENT_IDS.CHECKOUT_PLAN_INSTALL_DATE}>
                        {displayInstallationDate()}
                      </span>
                      <button
                        className="reviewCartNode-EditIcon"
                        onClick={handleEditInstallation}
                        title="Edit installation date"
                      >
                        <MdEdit />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderBottom: '1px solid #e0e0e0',
                  margin: '20px 0',
                }}
              ></div>
              {/* Add-Ons - Only show if there are selected add-ons */}
              {selectedAddOnsData?.selectedAddOns?.length > 0 && (
                <div className="reviewCartNode-SectionHeaderRow">
                  <div className="reviewCartNode-FirstCol">
                    <h4>Add-Ons</h4>
                  </div>
                  <div className="reviewCartNode-SecondCol">
                    {selectedAddOnsData.selectedAddOns.map((addon, index) => (
                      <div
                        key={addon.id || index}
                        className="reviewCartNode-AddOnItem"
                      >
                        <div>
                          <h4 className="reviewCartNode-AddOnName">
                            {addon.title}
                          </h4>
                          <div className="reviewCartNode-AddOnPriceText">
                            <span className="reviewCartNode-PriceAmount">
                              {addon.price}
                            </span>
                            <span className="reviewCartNode-PriceUnit">
                              /month
                            </span>
                          </div>
                        </div>
                        <button
                          className="reviewCartNode-TrashButton"
                          title="Remove add-on"
                        >
                          <MdDelete />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div
                style={{
                  borderBottom: '1px solid #e0e0e0',
                  margin: '20px 0',
                }}
              ></div>
              {/* One-Time Charges */}

              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <h4>One-Time Charges</h4>
                </div>
                <div className="reviewCartNode-SecondCol">
                  <div className="reviewCartNode-ChargesContent">
                    <div className="reviewCartNode-ChargeColumn">
                      <h5>Installation Fees</h5>
                      <span className="reviewCartNode-ChargeAmount">
                        $99.00
                      </span>
                    </div>
                    <div className="reviewCartNode-ChargeColumn reviewCartNode-CreditColumn">
                      <h5>Installation Credit</h5>
                      <span className="reviewCartNode-ChargeAmount reviewCartNode-CreditAmount">
                        $-99.00
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Payment Requirements */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">4</div>
                  <h4>Payment Requirements</h4>
                </div>
              </div>
              <div className="reviewCartNode-PaymentTable">
                <p className="reviewCartNode-PaymentNote">
                  <b>
                    {' '}
                    All scheduled installations must be paid in full at least 3
                    days before the installation date.
                  </b>{' '}
                  This includes any installation charges.
                </p>
                <table className="reviewCartNode-Table">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Details</th>
                      <th className="price-col">Cost (Before Installation)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Internet Services</td>
                      <td>
                        {selectedProduct?.description ||
                          'High-speed internet service'}
                      </td>
                      <td className="price-col">{getProductPrice()}</td>
                    </tr>
                    {selectedAddOnsData &&
                      selectedAddOnsData.selectedAddOns &&
                      selectedAddOnsData.selectedAddOns.map((addon) => (
                        <tr key={addon.id}>
                          <td>{addon.title}</td>
                          <td>Add-Ons</td>
                          <td className="price-col">{addon.price}</td>
                        </tr>
                      ))}
                    <tr>
                      <td
                        colSpan="2"
                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                      >
                       
                      </td>
                      <td className="price-col" style={{ fontWeight: 'bold', textAlign: 'right' }}>
  {(() => {
    const planPrice = parseFloat((getProductPrice() || '$0').replace('$', '')) || 0;
    const addOnsTotal = selectedAddOnsData ? parseFloat(selectedAddOnsData.totalAmount) || 0 : 0;
    const total = (planPrice + addOnsTotal).toFixed(2);
    return `Total $${total}`;
  })()}
</td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Monthly Recharge Amount */}
            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">5</div>
                  <h4>Monthly Recharge Amount</h4>
                </div>
              </div>
              <div className="reviewCartNode-PaymentTable">
                <table className="reviewCartNode-Table">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Details</th>
                      <th className="price-col">Cost (Monthly)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Internet Services</td>
                      <td>
                        {selectedProduct?.description ||
                          'High-speed internet service'}
                      </td>
                      <td className="price-col">{getProductPrice()}</td>
                    </tr>
                    {selectedAddOnsData &&
                      selectedAddOnsData.selectedAddOns &&
                      selectedAddOnsData.selectedAddOns.map((addon) => (
                        <tr key={addon.id}>
                          <td>{addon.title}</td>
                          <td>Add-Ons</td>
                          <td className="price-col">{addon.price}</td>
                        </tr>
                      ))}
                    <tr>
                      <td
                        colSpan="2"
                        style={{ textAlign: 'right', fontWeight: 'bold' }}
                      >
                      
                      </td>
                      <td className="price-col" style={{ fontWeight: 'bold', textAlign: 'right' }}>
  {(() => {
    const planPrice = parseFloat((getProductPrice() || '$0').replace('$', '')) || 0;
    const addOnsTotal = selectedAddOnsData
      ? parseFloat(selectedAddOnsData.totalAmount) || 0
      : 0;

    const total = (planPrice + addOnsTotal).toFixed(2);
    return `$${total}/mo`;
  })()}
</td>

                    </tr>
                  </tbody>
                </table>
                <div className="reviewCartNode-ValidityInfo">
                  <p>
                    <strong>Validity Period:</strong> 30 days from recharge
                  </p>
                  <p>
                    <strong>Recharge Date:</strong> On or before service start
                    date
                  </p>
                  <p className="reviewCartNode-Note">
                    * If your account balance is insufficient or not recharged
                    before the validity period ends, your service may be
                    suspended until the next successful recharge.
                  </p>
                </div>
              </div>
            </div>

            <div className="reviewCartNode-Section">
              <div className="reviewCartNode-SectionHeaderRow">
                <div className="reviewCartNode-FirstCol">
                  <div className="reviewCartNode-Circle">
                    {selectedAddOnsData?.selectedAddOns?.length > 0 ? '7' : '6'}
                  </div>
                  <h4>Prepay Settings</h4>
                </div>
                <div className="reviewCartNode-SecondCol">
                  <div className="reviewCartNode-PrivacySettings">
                    <div className="reviewCartNode-SettingItem">
                      <div className="reviewCartNode-SettingHeader">
                        <div className="reviewCartNode-SettingTitle">
                          <h3>Auto Pay</h3>
                        </div>
                        <div className="reviewCartNode-ToggleContainer">
                          <span className="reviewCartNode-ToggleLabel">
                            {autoPayEnabled ? 'Enabled' : 'Disabled'}
                          </span>
                          <label className="reviewCartNode-ToggleSwitch">
                            <input
                              type="checkbox"
                              id={ELEMENT_IDS.AUTOPAY_YES}
                              name="autopay"
                              checked={autoPayEnabled}
                              onChange={handleAutoPayToggle}
                            />
                            <span className="reviewCartNode-Slider"></span>
                          </label>
                        </div>
                      </div>
                      <p className="reviewCartNode-SettingDescription">
                        Payments are deducted automatically.
                      </p>
                      {autoPayEnabled && (
                        <div className="reviewCartNode-InfoBox">
                          <p>
                            Your AutoPay will process your payment 3 calendar
                            days before your next service start date. If the
                            payment fails for any reason, you will be notified
                            via text, email, outbound voice call, or Subscriber
                            Care registered number later than 2 days prior to
                            the next start date.
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="reviewCartNode-SettingItem">
                      <div className="reviewCartNode-SettingHeader">
                        <div className="reviewCartNode-SettingTitle">
                          <h3>Paperless Billing</h3>
                        </div>
                        <div className="reviewCartNode-ToggleContainer">
                          <span className="reviewCartNode-ToggleLabel">
                            {paperlessEnabled ? 'Enabled' : 'Disabled'}
                          </span>
                          <label className="reviewCartNode-ToggleSwitch">
                            <input
                              type="checkbox"
                              id={ELEMENT_IDS.PAPERLESS_YES}
                              name="paperless"
                              checked={paperlessEnabled}
                              onChange={handlePaperlessToggle}
                            />
                            <span className="reviewCartNode-Slider"></span>
                          </label>
                        </div>
                      </div>
                      <p className="reviewCartNode-SettingDescription">
                        Recharge receipts are delivered digitally.
                      </p>
                    </div>
                  </div>
                </div>
                {/* <button className="reviewCartNode-IconButton">
                  <MdEdit />
                </button> */}
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="reviewCartNode-OrderSummaryContainer">
            <div className="reviewCartNode-OrderSummary">
              <div className="reviewCartNode-SummaryHeader">
                <h4>Order Summary</h4>
                <span className="reviewCartNode-ItemCount">
                  ({1 + (selectedAddOnsData?.addOnsCount || 0)} items)
                </span>
              </div>

              <div className="reviewCartNode-SummaryDetails">
                <div className="reviewCartNode-SummaryItem">
                  <span>
                    Plan (Internet Service{' '}
                    {getProductName().replace('Internet Service', '').trim()})
                  </span>
                  <span id={ELEMENT_IDS.CHECKOUT_ORDER_VALUE}>
                    {getProductPrice()}
                  </span>
                </div>
                {selectedAddOnsData &&
                  selectedAddOnsData.selectedAddOns &&
                  selectedAddOnsData.selectedAddOns.map((addon) => (
                    <div key={addon.id} className="reviewCartNode-SummaryItem">
                      <span>{addon.title}</span>
                      <span>{addon.price}</span>
                    </div>
                  ))}
                <div className="reviewCartNode-SummaryItem">
                  <span>Modem Rental</span>
                  <span id={ELEMENT_IDS.CHECKOUT_MODEM_RENTAL}>
                    {mockData.modemRental}
                  </span>
                </div>
                <div className="reviewCartNode-SummaryItem reviewCartNode-InstallationFee">
                  <span>Installation</span>
                  <span style={{ color: 'green' }}>$0.00</span>
                </div>
                {/* Only show discount line if discount > 0 */}
                {calculateDiscount() > 0 && (
                  <div className="reviewCartNode-SummaryItem">
                    <span>Discounts</span>
                    <span
                      id={ELEMENT_IDS.CHECKOUT_DISCOUNT}
                      style={{ color: 'green' }}
                    >
                      -${calculateDiscount().toFixed(2)}
                    </span>
                  </div>
                )}
              </div>

              {/* Discount note - Always show to inform users */}
              <p className="reviewCartNode-DiscountNote">
                {autoPayEnabled && paperlessEnabled ? (
                  <>✓ Discounts applied for AutoPay and Paperless Billing</>
                ) : autoPayEnabled ? (
                  <>
                    ✓ Discount applied for AutoPay. Enable Paperless Billing for
                    additional <strong>$5</strong> discount
                  </>
                ) : paperlessEnabled ? (
                  <>
                    ✓ Discount applied for Paperless Billing. Enable AutoPay for
                    additional <strong>$5</strong> discount
                  </>
                ) : (
                  <>
                    {' '}
                    Enable AutoPay and Paperless Billing to save{' '}
                    <strong>$10/month</strong>
                  </>
                )}
              </p>

              <div className="reviewCartNode-OrderTotal">
                <span>Order Total*</span>
                <span id={ELEMENT_IDS.CHECKOUT_ORDER_TOTAL}>
                  $
                  {(() => {
                    const planPrice = parseFloat(
                      (getProductPrice() || '$0').replace('$', '')
                    );
                    const addOnsTotal = selectedAddOnsData
                      ? selectedAddOnsData.totalAmount
                      : 0;
                    const modemRental = parseFloat(
                      mockData.modemRental.replace('$', '')
                    );
                    const discount = calculateDiscount();

                    const total =
                      planPrice + addOnsTotal + modemRental - discount;
                    return total.toFixed(2);
                  })()}
                </span>
              </div>
              <p className="reviewCartNode-TaxNote">
                * Taxes and regulatory fees are not included under the Order
                Total
              </p>
              <Button
                customId={ELEMENT_IDS.CHECKOUT_PROCEED_BUTTON}
                label="Proceed"
                right={<span className="reviewCartNode-PsnArrow">→</span>}
                fullWidth
              />
            </div>
            <div className="reviewCartNode-HelpText">
              Need help with your order? <strong>Call 843-538-2020</strong>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default ReviewCartAlternate;
